import BenefitsSection from '@/v2/components/sections/common/benefits-section'
import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionSectionContent,
  expertTipsSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionSectionContent,
  whyChooseUsSectionContent,
  WhyWeSectionContent
} from '@/v2/constants/pages/public-pages/how-storage-services-works-page'

interface HowStorageServicesWorksPageProps {}

const HowStorageServicesWorksPage: React.FC<HowStorageServicesWorksPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[345px] max-h-[222px] 
        lg:!w-[460px] lg:!max-h-[296px] 
        xl-min:!w-[713px] xl-min:!max-h-[458px]
      '
        btnClassName='xl-min:!w-[269px] lg-mn:h-[50px] md-mn:w-[226px] w-[259px] h-[44px]'
      />
      <WhyWeSection {...WhyWeSectionContent} isBgDark />
      <HelperSection {...whyChooseUsSectionContent} buttonClassName='xl-min:!w-[262px] md-mn:w-[251px] w-[257px]' />
      <ServiceTipsSectionSection {...serviceTipsSectionSectionContent} isBgDark />
      <BenefitsSection {...benefitsSectionSectionContent} />
      <ForWhoSection {...forWhoSectionContent} isBgDark />
      <WhyWeSection {...expertTipsSectionContent} className='[&_article]:bg-transparent [&_article]:border-none' />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
      />
      <FaqSection {...faqSectionContent} isBgDark />
    </>
  )
}

export default HowStorageServicesWorksPage
